import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppButton from "../../components/AppButton";
import TextInput from "../../components/TextInput";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";

import "./auth.styles.css";
import { LoginSchema } from "./ValidationSchema";
import Auth from "@aws-amplify/auth";

const LoginPage = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const loginUser = async ({ email, password }) => {
    setIsLoading(true);

    setErrorMessage(null);

    try {
      const { attributes } = await Auth.signIn(email, password);

      return attributes;
    } catch (error) {
      console.log("There was a problem signing in the user", error);
      setErrorMessage(error.message);
    }

    setIsLoading(false);
  };

  console.log("errorMessage", errorMessage);
  return (
    <div className="auth__wrapper">
      <div className="auth__wrapper--left">
        <p>
          The standard Lorem Ipsum passage, used since the 1500s "Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris num."
        </p>
        <span>Dave, Product manager.</span>
        <span className="staricon">
          <svg
            width="326"
            height="390"
            viewBox="0 0 326 390"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M186.372 36.3389C190.287 32.3472 193.947 28.1124 197.33 23.6595L196.011 43.322C190.535 124.956 225.007 204.546 288.459 256.777L323.227 285.396C221.606 267.515 122.842 326.997 91.6221 425.209L74.8061 478.108C59.1196 370.143 -30.1724 287.228 -139.004 279.951L-149.149 279.273C-55.7233 246.855 -2.70966 148.251 -27.119 51.4925L-39.4814 2.48749L-4.27459 37.1287C49.085 89.6308 134.44 89.2836 186.372 36.3389Z"
              stroke="#FBFBFB"
            />
          </svg>
        </span>
      </div>
      <div className="auth__wrapper--right w--full">
        <div className="auth__wrapper--rightMain">
          <h1 className="font--38">Sign in to get started</h1>

          <Formik
            validationSchema={LoginSchema}
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              email: "",
              password: "",
            }}
            onSubmit={async (values) => {
              const result = await loginUser({ ...values });
              if (result) {
                history.push("/course");
              }
            }}
          >
            {({
              values,
              handleSubmit,
              handleChange,
              handleBlur,
              errors,
              touched,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="w--full mt--16">
                  <TextInput
                    label="Email address"
                    placeholder="johnsmith@gmail.com"
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                    onBlur={handleBlur}
                    withError={errors.email && touched.email}
                    errorMessage={
                      errors.email &&
                      touched.email &&
                      "Please enter your email address"
                    }
                  />
                </div>
                <div className="w--full mt--16">
                  <TextInput
                    name="password"
                    label="Password"
                    placeholder="*************"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    withError={errors.password && touched.password}
                    errorMessage={
                      errors.password &&
                      touched.password &&
                      "Please enter your password"
                    }
                  />
                </div>
                {errorMessage && (
                  <div className="mt--16">
                    <p className="loginError">{errorMessage}</p>
                  </div>
                )}
                <div className="w--full">
                  <AppButton
                    title="Log into my account"
                    styles={{ width: "100%", marginTop: 16 }}
                    type="submit"
                    isLoading={isLoading}
                  />
                </div>
                <div className="mt--16">
                  <p>
                    Forgotten your password?{" "}
                    <Link to="/forgot-password" className="font--regular">
                      Reset here
                    </Link>
                  </p>

                  <p>
                    Do not have an account? <Link to="/signup">Sign up</Link>
                  </p>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
